<template>
	<section class="w3l-contact-1 w3hny-form-btm py-5" id="contact">
		<div class="contacts-9 py-lg-5 py-md-4">
			<div class="container">
				<div class="header-sec text-center mb-5">
					<br />
					<h1 class="title-w3l">
						Success
					</h1>
				</div>
				<div class="contactct-fm map-content-9">
					<p>You have successfully verified your email address. You can now log in.</p>
				</div>
			</div>
		</div>
	</section>
</template>

<script setup lang="ts">
useHead({
  //@ts-ignore
  title: `ForumLeadsFinder – You entered a valid verification code`,
  meta: [
    {
      name: "description",
      //@ts-ignore
      content: `ForumLeadsFinder - Excellent. Your verification code has been approved. You can now log into the system`
    }
  ]
});
</script>



<style scoped></style>